// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  height: 0;
  transition: height 0.5s;
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 9;
  background: #fff;
  font-size: 0.875rem;
  box-shadow: 0 2.125rem 70px rgba(0, 0, 0, 0.07);
}

.menu-section {
  width: 100%;
  padding: 0.8125rem 4.4375rem 0.125rem;
  display: flex;
  flex-wrap: wrap;
}
.menu-section .linking-section {
  padding-right: 0.5rem;
  min-width: 130px;
  width: 16.5%;
}
.menu-section .linking-section .heading {
  font-size: 1.28rem;
  padding-top: 0.375rem;
  font-weight: bold;
  color: var(--ion-black-primary);
}
.menu-section .linking-section ul {
  list-style: none;
  padding-left: 0;
  padding-right: 0;
  color: var(--ion-grey1);
}
.menu-section .linking-section ul li {
  cursor: pointer;
  font-size: 0.9em;
  padding-bottom: 0.3125rem;
}
.menu-section .linking-section ul li:hover {
  text-decoration: underline;
}

.mobile-wrapper .category-section {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  font-size: 0.875rem;
}
.mobile-wrapper .category-section .left-section {
  width: 80px;
  height: 80px;
}
.mobile-wrapper .category-section .right-section {
  display: flex;
  align-items: center;
  width: calc(100% - 80px);
  border-bottom: 1px solid var(--ion-divider);
  padding-bottom: 0.625rem;
  min-height: 80px;
  margin-left: 1rem;
}
.mobile-wrapper .category-section .right-section .category-part {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem;
  padding-left: 0;
  width: calc(100% - 16px);
  min-height: 80px;
  color: var(--ion-color-tertiary-blue);
}
.mobile-wrapper .category-section .right-section .category-part .category {
  font-size: 1.28rem;
  color: var(--ion-black-primary);
}

@media screen and (max-width: 992px) {
  .menu-section {
    padding: 0.8125rem 0.625rem 0.125rem;
  }
  .menu-section .linking-section {
    width: 24%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menus/menus.component.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;AACJ;;AAEA;EACI,WAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;AACJ;AACI;EACI,qBAAA;EACA,gBAAA;EACA,YAAA;AACR;AACQ;EACI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,+BAAA;AACZ;AAEQ;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAAZ;AAEY;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;AAAhB;AAGY;EACI,0BAAA;AADhB;;AASI;EACI,aAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AANR;AAQQ;EACI,WAAA;EACA,YAAA;AANZ;AASQ;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,2CAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;AAPZ;AASY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,qCAAA;AAPhB;AASgB;EACI,kBAAA;EACA,+BAAA;AAPpB;;AAcA;EACI;IACI,oCAAA;EAXN;EAaM;IACI,UAAA;EAXV;AACF","sourcesContent":[".wrapper {\n    height: 0;\n    transition: height .5s;\n    overflow: hidden;\n    position: absolute;\n    width: 100%;\n    z-index: 9;\n    background: #fff;\n    font-size: 0.875rem;\n    box-shadow: 0 2.125rem 70px rgba(0, 0, 0, 0.07);\n}\n\n.menu-section {\n    width: 100%;\n    padding: 0.8125rem 4.4375rem 0.125rem;\n    display: flex;\n    flex-wrap: wrap;\n\n    .linking-section {\n        padding-right: 0.5rem;\n        min-width: 130px;\n        width: 16.5%;\n\n        .heading {\n            font-size: 1.28rem;\n            padding-top: 0.375rem;\n            font-weight: bold;\n            color: var(--ion-black-primary);\n        }\n\n        ul {\n            list-style: none;\n            padding-left: 0;\n            padding-right: 0;\n            color: var(--ion-grey1);\n\n            li {\n                cursor: pointer;\n                font-size: .9em;\n                padding-bottom: 0.3125rem;\n            }\n\n            li:hover {\n                text-decoration: underline;\n            }\n        }\n    }\n\n}\n\n.mobile-wrapper {\n    .category-section {\n        display: flex;\n        align-items: flex-start;\n        padding: 1rem;\n        font-size: 0.875rem;\n\n        .left-section {\n            width: 80px;\n            height: 80px;\n        }\n\n        .right-section {\n            display: flex;\n            align-items: center;\n            width: calc(100% - 80px);\n            border-bottom: 1px solid var(--ion-divider);\n            padding-bottom: 0.625rem;\n            min-height: 80px;\n            margin-left: 1rem;\n\n            .category-part {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                padding: 0.5rem;\n                padding-left: 0;\n                width: calc(100% - 16px);\n                min-height: 80px;\n                color: var(--ion-color-tertiary-blue);\n\n                .category {\n                    font-size: 1.28rem;\n                    color: var(--ion-black-primary);\n                }\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .menu-section {\n        padding: 0.8125rem 0.625rem 0.125rem;\n\n        .linking-section {\n            width: 24%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
